<ng-content select="app-chapter-card-img"></ng-content>
<div
  class="d-flex justify-content-between gpl-16 gpr-12 gpx-sm-24 align-items-center w-100"
>
  <ng-content select="[body]"></ng-content>
  <ng-content select="[action]"></ng-content>
</div>
